export enum UploadFileTypeEnum {
  JPG = 'image/jpg',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  SVG = 'image/svg+xml',
  PDF = 'application/pdf',
}

export enum FormatFileEnum {
  JPG = 'jpg',
  PNG = 'png',
  JPEG = 'jpeg',
  SVG = 'svg+xml',
  PDF = 'pdf',
}
